
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const REACT_APP_MAP_API_PRODUCTION_URL = process.env.REACT_APP_MAP_API_PRODUCTION_URL;
const REACT_APP_MAP_API_DEV_URL = process.env.REACT_APP_MAP_API_DEV_URL;

const REACT_APP_MAP_ID_PROD = process.env.REACT_APP_MAP_ID_PROD;
const REACT_APP_MAP_API_KEY_PROD = process.env.REACT_APP_MAP_API_KEY_PROD;

const REACT_APP_MAP_ID_DEV = process.env.REACT_APP_MAP_ID_DEV;
const REACT_APP_MAP_API_KEY_DEV = process.env.REACT_APP_MAP_API_KEY_DEV;


// console.log('REACT_APP_MAP_ID_DEV:', REACT_APP_MAP_ID_DEV);

const apiURLs = {
  getHomeBannerDataURL: REACT_APP_API_BASE_URL + 'banner',
  // getLeaderboardDataURL: REACT_APP_API_BASE_URL + 'polls/twice/leaderboard',
  getLeaderboardDataURL: REACT_APP_API_BASE_URL + 'polls/blink/leaderboard',
  getCouponsDataURL: REACT_APP_API_BASE_URL + 'dashtaxi/coupons',
  postTaxiGameCompleteDataURL: REACT_APP_API_BASE_URL + 'dashtaxi/complete',
  getTaxiGameIntroDataURL: REACT_APP_API_BASE_URL + 'dashtaxi/progress',
  getIGPostsDataURL: REACT_APP_API_BASE_URL + 'instagram/posts',
  getLiveMapDataURL: REACT_APP_MAP_API_PRODUCTION_URL + 'v2/public/promo/heartbeats/blackpink_2026',
  // getLiveMapDataURLDev: REACT_APP_MAP_API_DEV_URL + 'v2/public/promo/heartbeats/twice_2025',
  // https://api.dash-hk.com/v2/public/promo/heartbeats/blackpink_2026
  // postTwiceGameVotingDataURL: REACT_APP_API_BASE_URL + 'polls/twice/vote/',
  postTwiceGameVotingDataURL: REACT_APP_API_BASE_URL + 'polls/blink/vote/',

  postSendOtpURLProd: REACT_APP_MAP_API_PRODUCTION_URL + 'v2/auth/send-otp',
  postVerifyOtpURLProd: REACT_APP_MAP_API_PRODUCTION_URL + 'v2/auth/verify-otp',
  postSendOtpURLDev: REACT_APP_MAP_API_DEV_URL + 'v2/auth/send-otp',
  postVerifyOtpURLDev: REACT_APP_MAP_API_DEV_URL + 'v2/auth/verify-otp',

  getMapIDProd: REACT_APP_MAP_ID_PROD, 
  getMapAPIKeyProd: REACT_APP_MAP_API_KEY_PROD, 
  getMapIDDev: REACT_APP_MAP_ID_DEV, 
  getMapAPIKeyDev: REACT_APP_MAP_API_KEY_DEV, 
};
export default apiURLs;